module.exports = __webpack_public_path__ + "img/public/TrustIcons/Mail.svg?94679848";